module.exports = __webpack_public_path__ + "img/3.65d37bd8.jpg";